import { apiClient } from '@/lib/api'

/**
 * Geolocate API - Regions, Cities
 */

// Cities
export const citiesApi = {
  getAutocomplete: (params = {}) => apiClient.get('/v1/geolocate/cities/autocomplete/', { params }),
}

// Regions
export const regionsApi = {
  getAutocomplete: (params = {}) => apiClient.get('/v1/geolocate/regions/autocomplete/', { params }),
}
